import Vue from "vue";
import Vuex from "vuex";
import content from "./modules/content";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

const dataState = createPersistedState({
  paths: ['content.blocks','content.menus']
})

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    content
  },
  plugins: [dataState]
});
